import { getToken, isEmailTaken } from 'api/request'
import DeviceId from 'utils/detectDevice'
import { trackValidationErrors } from 'tracking/form'

const requiredErrorMessages = {
  email: 'Please specify Email Id',
  password1: 'Please enter 4 to 20 characters password without any spaces',
  first_name: 'Please specify full name',
  last_name: 'Please specify full name',
  day: 'Please specify Date of Birth',
  month: 'Please specify Date of Birth',
  year: 'Please specify Date of Birth',
  invalidDoB: 'Please check the Date of Birth',
  community: 'Please specify Religion',
  mother_tongue: 'Please specify Community',
  countryofresidence: 'Please specify location',
  gender: 'Please specify gender',
}

const monthNumericMap = {
  Jan: '01',
  Feb: '02',
  Mar: '03',
  Apr: '04',
  May: '05',
  Jun: '06',
  Jul: '07',
  Aug: '08',
  Sep: '09',
  Oct: '10',
  Nov: '11',
  Dec: '12',
}

const fieldHasErr = ({ meta }) => meta.touched && meta.error
const inputHasErr = meta => meta.touched && meta.error

const required = fieldName => value =>
  value ? undefined : requiredErrorMessages[fieldName]
// const mustBeNumber = value => (isNaN(value) ? 'Must be a number' : undefined)
const noSpaces = fieldName => value =>
  value.indexOf(' ') >= 0 ? requiredErrorMessages[fieldName] : undefined
const minValue = (fieldName, min) => value =>
  value.length >= min ? undefined : requiredErrorMessages[fieldName]
const validEmail = value =>
  new RegExp(/^[\w_-]+(\.[\w_-]+)*@[\w_-]+(\.[\w_-]+)*\.\w{2,4}$/gi).test(value)
    ? undefined
    : 'Please enter correct Email'

const noRepeatingCharacters = value =>
  new RegExp(/([a-zA-Z])\1{2,}/gi).test(value)
    ? 'No repeating characters please'
    : undefined

const noSpecialCharacters = value =>
  new RegExp(/[^a-zA-Z]/gi).test(value)
    ? 'No special characters please'
    : undefined

const characterLimit = (fieldName, limit) => value =>
  value && value.length > limit
    ? `${fieldName} cannot be more than ${limit} characters`
    : undefined

const composeValidators = (...validators) => value =>
  validators.reduce((error, validator) => error || validator(value), undefined)

const simpleMemoize = fn => {
  let lastArg
  let lastResult
  return arg => {
    if (arg !== lastArg) {
      lastArg = arg
      lastResult = fn(arg)
    }
    return lastResult
  }
}

export const EMAIL_ALREADY_EXISTS_ERROR_CODE =
  'email_address_already_registered'

const uniqueEmail = simpleMemoize(
  async (value, emailExistsErrorCode = EMAIL_ALREADY_EXISTS_ERROR_CODE) => {
    try {
      let token = await getToken()
      let response = await isEmailTaken(token, value)
      if (
        response.error &&
        response.error.status === 400 &&
        response.error.message_shortcode === emailExistsErrorCode
      ) {
        trackValidationErrors({ fieldValue: emailExistsErrorCode })
        return response.error.message_shortcode
      }
    } catch (error) {
      console.log('err', error)
    }
    return undefined
  }
)

const isEqualTo = (compareValue, compareValueWith) =>
  parseInt(compareValue) === parseInt(compareValueWith)

const isValidDate = (year, month, day) => {
  const formatedMonth = month - 1
  const selectedDate = new Date(year, formatedMonth, day)
  if (
    isEqualTo(selectedDate.getFullYear(), year) &&
    isEqualTo(selectedDate.getMonth(), formatedMonth) &&
    isEqualTo(selectedDate.getDate(), day)
  ) {
    return true
  }
  return false
}

const validateLegalAge = (gender, day, month, year) => {
  const derivedAge = Math.floor(
    (new Date() - new Date(`${year}-${month}-${day}`).getTime()) / 3.15576e10
  )

  const legalMarriageAge = gender === 'Male' ? 21 : 18

  return derivedAge < legalMarriageAge ||
    !isValidDate(year, monthNumericMap[month], day)
    ? requiredErrorMessages['invalidDoB']
    : undefined
}

const checkLegalAge = values => {
  const errors = {}
  const legalAgeErr =
    values.gender &&
    values.day &&
    values.month &&
    values.year &&
    validateLegalAge(
      values.gender,
      DeviceId.isMobile() ? values.day : values.day.value,
      DeviceId.isMobile() ? values.month : values.month.value,
      DeviceId.isMobile() ? values.year : values.year.value
    )

  if (legalAgeErr) {
    errors.day = legalAgeErr
    errors.month = legalAgeErr
    errors.year = legalAgeErr
    return errors
  }
}

export {
  required,
  noSpaces,
  validEmail,
  minValue,
  uniqueEmail,
  fieldHasErr,
  inputHasErr,
  composeValidators,
  checkLegalAge,
  validateLegalAge,
  monthNumericMap,
  noRepeatingCharacters,
  characterLimit,
  noSpecialCharacters,
}
